import { DATASOURCE } from 'Constants'
import { splitNameAndVersion } from 'helpers/device_helper'

const initialState = {
  data: [],
  total: 0,
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.CALLSUPDATE.KEY:
      return {
        ...state,
        data: processUpdateCalls(state.data, action.data.records),
        total: action.data.totalCount.value,
        loading: false
      };
    case DATASOURCE.CALLSREFRESH.KEY:
      return {
        ...state,
        data: processReplaceCalls(action.data.records),
        total: action.data.totalCount.value,
        loading: false
      };
    case DATASOURCE.CALLSUPDATE.LOADING:
    case DATASOURCE.CALLSREFRESH.LOADING:
      return {
        ...state,
        loading:true
      };
    default:
      return state;
  }
};

function processReplaceCalls(records) {
  records.forEach(record => {
    let s = splitNameAndVersion(record.agent);
    let idx = 0;
    if (s.length > 0 && s[0] === "Unknown") {
      idx = 1;
    }
    record.agent = s.slice(idx).join(" ");
    record.dialString = record.dialString ? record.dialString : record.dialNumber;
    record.deploymentType = record.deployment.toLowerCase().startsWith("teams") ? "Teams" : "Skype";
    
  });
  
  return records;
}

function processUpdateCalls(existingCalls, newRecords) {
  newRecords.forEach(record => {
    let s = splitNameAndVersion(record.agent);
    let idx = 0;
    if (s.length > 0 && s[0] === "Unknown") {
      idx = 1;
    }
    record.agent = s.slice(idx).join(" ");
    record.dialString = record.dialString ? record.dialString : record.dialNumber;
    record.deploymentType = record.deployment.toLowerCase().startsWith("teams") ? "Teams" : "Skype";
    
  });
  
  return [...existingCalls,...newRecords];
}

